module.exports = __webpack_public_path__ + "8464272c3d74c0af5c292cd7ac48a15b.svg";